import type { ReactNode } from 'react';

export type CalloutTone = 'info' | 'warn' | 'error' | 'accent';

export function Callout({
  tone = 'info',
  title,
  children,
}: {
  tone?: CalloutTone;
  title?: string;
  children: ReactNode;
}) {
  return (
    <div className={`callout callout--${tone}`} role={tone === 'error' ? 'alert' : undefined}>
      {title ? <p className="callout__title">{title}</p> : null}
      {children}
    </div>
  );
}

/** A short list inside a callout: build notes, map warnings, what to change. */
export function CalloutList({ items }: { items: readonly string[] }) {
  if (items.length === 0) return null;
  return (
    <ul className="callout__list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}
